export const mapBBRDataToInputValue = (
	data: { id: string; label?: string; type: string; value: string } | undefined,
	metaArea: MetaArea | undefined
): string | undefined => {
	const apiFieldListOfValuesMappingItems = metaArea?.items?.[0]?.content?.apiFieldListOfValuesMappings?.items ?? [];

	const mappingForCurrentField = apiFieldListOfValuesMappingItems.find(
		(mappingItem) => mappingItem.content.fieldIdentifier.uid === data?.id
	);

	const mappedData = mappingForCurrentField?.content.logicalNameMappings.find(
		(mapping) => mapping.value === data?.value
	);

	return mappedData?.key;
};
